"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var tools_1 = require("../utils/tools");
var NAME = 'sub';
var Sub = /** @class */ (function (_super) {
    __extends(Sub, _super);
    function Sub() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function () { return 'sub'; };
        _this.excludes = 'sup';
        _this.parseDOM = [{ tag: 'sub', priority: 25 }];
        return _this;
    }
    return Sub;
}(core_utilities_1.Inline));
exports.Sub = Sub;
var SubController = /** @class */ (function (_super) {
    __extends(SubController, _super);
    function SubController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.toolbar = {
            className: 'sub',
            tooltip: 'sub'
        };
        _this.disable = function (editor) {
            return tools_1.checkMarkDisable(editor.view, NAME);
        };
        return _this;
    }
    return SubController;
}(core_utilities_1.SylController));
exports.SubController = SubController;
var SubPlugin = /** @class */ (function (_super) {
    __extends(SubPlugin, _super);
    function SubPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = SubController;
        _this.Schema = Sub;
        return _this;
    }
    return SubPlugin;
}(core_utilities_1.SylPlugin));
exports.SubPlugin = SubPlugin;
//# sourceMappingURL=sub.js.map